import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription, map } from "rxjs";
import { AppState } from 'src/app/store/app.reducer';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Ticket } from 'src/app/model/ticket';
import { selectSites } from 'src/app/store/site/site.selector';
import { selectTickets } from 'src/app/store/ticket/ticket.selector';
import { User } from 'src/app/model/user';
import * as SiteActions from 'src/app/store/site/site.actions';
import { Site } from 'src/app/model/site';
import { StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';

@Component({
	templateUrl: './technician-edit.dialog.component.html',
})

export class TechnicianEditDialogComponent implements OnInit, OnDestroy {
	tickets: Ticket[];
	tickets$: Observable<Ticket[] | undefined>;
	ticketsSub: Subscription | undefined;

	sites$: Observable<Site[] | undefined>;
	sitesSub: Subscription | undefined;

	technician: User;
	sites: Site[];

	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
		public config: DynamicDialogConfig,
	) {
		this.technician = config.data.technician;
		this.initSelectors();
	}

	ngOnInit(): void {
		this.subscribeAll();
		this.onResize();
	}

	initSelectors(): void {
		// Store selectors
		this.tickets$ = this.store.select(selectTickets);
		this.sites$ = this.store.select(selectSites);
	}

	subscribeAll(): void {
		this.ticketsSub = this.tickets$?.subscribe(
			(tickets) => {
				this.tickets = tickets;
			}
		);
		this.sitesSub = this.sites$?.pipe(
			map(sites => sites.filter(site => site.CurrentlyOwned))
		).subscribe(
			(sites) => {
				this.sites = sites.sort((a, b) => { return a.Name < b.Name ? -1 : 1 });
			}
		);
	}

	ngOnDestroy(): void {
		this.ticketsSub?.unsubscribe();
		this.sitesSub?.unsubscribe();
	}

	assigned(site: Site): boolean {
		return site.TechnicianId !== undefined && site.TechnicianId !== null;
	}

	canChange(site: Site): boolean {
		return (!this.assigned(site) || this.associatedToCurrentTechnician(site)) && !this.anyOpenTicketOn(site);
	}

	anyOpenTicketOn(site: Site): boolean {
		return this.tickets.some(t => t.SiteId === site.Id && t.FlagClosed === false);
	}

	onCheckChange(checked: boolean, site: Site): void {
		if (checked) {
			this.store.dispatch(SiteActions.assignTechnician({ siteId: site.Id, technicianId: this.technician.Id }));
		} else {
			this.store.dispatch(SiteActions.unassignTechnician({ siteId: site.Id }));
		}
	}

	associatedToCurrentTechnician(site: Site): boolean {
		return site.TechnicianId === this.technician.Id;
	}

	closeDialog(): void {
		this.ref.close();
	}

	truncateString(str: string, num: number): string {
		if (str.length > num) {
			return str.slice(0, num) + "...";
		} else {
			return str;
		}
	}

	getTruncateNameDescr(site: Site): string {
		const name = site.Name;
		const descr = site.Description;
		let finalStr = "";

		if (name != undefined) {
			finalStr = finalStr + this.truncateString(name, 115);
		} else {
			return "";
		}

		if (descr != undefined) {
			finalStr = finalStr + '\n' + '(' + this.truncateString(descr, 100) + ')';
		} else {
			return "";
		}

		return finalStr;
	}

	// Design
	@HostListener('window:resize')
	onResize(): void {
		this.screenWidth = window.innerWidth;
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	col4ResponsiveStd(): string {
		return StandardPageLayout.col4ResponsiveStd(this.screenWidth);
	}
}
